import React from "react";

interface SmallModalProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const SmallModal: React.FC<SmallModalProps> = ({
  title,
  isOpen,
  onClose,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="bg-white rounded-2xl shadow-lg w-[340px] max-w-[90%] p-6 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-red-500"
        >
          ✕
        </button>

        {/* Title */}
        <h2 className="text-lg font-semibold text-center mb-4">{title}</h2>

        {/* Content */}
        <div>{children}</div>
      </div>
    </div>
  );
};

export default SmallModal;
